/**
 * AUTO-GENERATED by scripts/generate-cvent-plan.mjs — DO NOT EDIT BY HAND.
 *
 * Source of truth: src/analytics/cvent/actions/*.json.
 * Regenerate with: pnpm attendee-activities:generate-plan
 */
import { Action, type AttendeeActivitiesActionProps } from '@cvent/analytics/Action';

/**
 * Props for the "chat message sent" Attendee Activities fact.
 *
 * Extends `AttendeeActivitiesActionProps`, which requires `objectId`. For this
 * fact the `objectId` mirrors `sessionId`.
 */
export interface ChatMessageSentProps extends AttendeeActivitiesActionProps {
  /** Cvent session identifier the message was sent in. */
  sessionId: string;

  /** Server-assigned Mattermost post id of the sent message. */
  messageId: string;

  /** Whole seconds into the stream when the message was sent. */
  streamOffsetSeconds?: number;
}

/**
 * `@cvent/analytics` Action model for the "chat message sent" fact.
 *
 * The `id` is the Attendee Activities `activity_type`. Routing is not set per action — the
 * singleton's `defaultDestinations` (`CVENT_ANALYTICS_DESTINATIONS`) routes
 * every fact, matching `../actions/chat_message_sent.json`.
 *
 * @description Tracks when an attendee sends a session chat message during a Goldcast session, publishing to the Cvent Attendee Activities pipeline to build a unified record of attendee engagement. The message text is never published.
 * @trigger Fired once an attendee's session chat message is confirmed by the server during a live or simulive session.
 */
export default class ChatMessageSent extends Action<ChatMessageSentProps> {
  id = 'session.chatMessageSent';
}
